import { 
  getDatabase, 
  ref, 
  set, 
  remove, 
  push as firebasePush, 
  update as firebaseUpdate 
} from 'firebase/database';
import { Category } from '../types/menu';

export const createCategory = async (category: Omit<Category, 'id'>): Promise<string> => {
  const db = getDatabase();
  const categoriesRef = ref(db, 'categories');
  const newCategoryRef = firebasePush(categoriesRef);
  
  await set(newCategoryRef, {
    ...category,
    id: newCategoryRef.key
  });
  
  return newCategoryRef.key ?? '';
};

export const updateCategory = async (id: string, updates: Partial<Category>): Promise<void> => {
  const db = getDatabase();
  const categoryRef = ref(db, `categories/${id}`);
  await firebaseUpdate(categoryRef, updates);
};

export const deleteCategory = async (id: string): Promise<void> => {
  const db = getDatabase();
  const categoryRef = ref(db, `categories/${id}`);
  await remove(categoryRef);
}; 